import React from 'react';
import '../Section10/component.css';

const Section18 = () => {
  return (
    <div className="svc-intro">

      <div className="svc-intro-inner">
        <span className="svc-label">Development</span>
        <h2 className="svc-intro-title">Your Expert Partner in Software Development</h2>
        <p className="svc-intro-body">
          At Hypertonic It Solutions, we specialize in providing top-notch software development solutions tailored to meet the diverse needs of businesses and organizations across various industries. With our team of skilled developers, we are committed to delivering high-quality, custom software solutions that empower our clients to streamline their operations, enhance productivity, and achieve their business objectives.
        </p>
      </div>
    </div>
  );
};

export default Section18;
